import { loggerCan } from '@/data/utils/loggerUtil';
import { ContentType, HttpClient, RequestParams } from './http-client';
import { logger } from '@/logging/logger';

export class Department<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;
	traceDetails: string | undefined;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

	findDepartment = (
		storeId: string,
		query?: {
			catentries?: string | string[];
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('findDepartment'))
		) {
			const paramsLogger = logger.child({
				params,
				query: query ?? {},
				body: {},
				methodName: 'findDepartment',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}

		return this.http.request<
			{
				departments: Record<string, string>;
			},
			void
		>({
			path: `/store/${storeId}/department/findbyIds`,
			method: 'GET',
			query: query,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
}
